import {
    ASSORTMENT_TOTALS_ROW,
    formatValueOnPlanAndTotalType,
    getCurrency,
    getPlanRowType,
} from "../grid-renderers/pinned-row-renderers";
import { TotalTypes } from "../grid-renderers/pinned-row-renderers/pinned-row-constants";
import { ValueFormatterParams } from "ag-grid-community";
import { IMAGE_URL, Kinds } from "constants/product-collection";
export const pinnedValueFormatter = (params: ValueFormatterParams) => {
    const { value, colDef, data, node, columnApi } = params;
    // On image column, which is always first column on the grid,
    // print plan label instead of value
    if (colDef.colId === IMAGE_URL) {
        return value;
    }

    const { allocationReferenceFields, kind, doors, currency: merchantCurrency } = colDef.cellRendererParams || {};
    const totalType = data?.totalType;

    if ((typeof value !== "number" && !value) || !totalType || !data || !allocationReferenceFields) {
        return "";
    }

    if (totalType === ASSORTMENT_TOTALS_ROW) {
        return value;
    }

    // If data has no `plan`, we take this as Totals instead of Plan.
    const planRowType = data?.plan ? getPlanRowType(node.rowIndex) : undefined;

    let currency = getCurrency(totalType as TotalTypes, allocationReferenceFields, columnApi);
    // if it's total kind, get currency from merchantCurrency.
    if ([Kinds.TOTAL_ALLOCATION_DIMENSIONS, Kinds.DOOR_BULK_QUANTITY].includes(kind) && !!doors?.length) {
        currency = merchantCurrency;
    }

    return formatValueOnPlanAndTotalType({ value, totalType, currency, planRowType });
};
